import { Injectable } from '@angular/core';
import { ApiService } from '../data/api.service';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { NavigationMenuGroup } from '../../models/navigation/navigation-menu-group.model';

@Injectable({
    providedIn: 'root',
})
export class NavMenuService {
    public error: any;
    public hasError: boolean;
    public showMenu: boolean = true;
    constructor(private apiService: ApiService) {
    }
    public getGroups(): Observable<NavigationMenuGroup[]> {
        return this.apiService.get<NavigationMenuGroup[]>(`api/NavigationMenuItems`).pipe(
            catchError(error => this.handleError(error))
        );
    }
    public getGroupsLoggedOut(): Observable<NavigationMenuGroup[]> {
        return this.apiService.get<NavigationMenuGroup[]>(`api/NavigationMenuItems/GetMenuLoggedOut`).pipe(
            catchError(error => this.handleError(error))
        );
    }
    private handleError(error: HttpErrorResponse) {
        this.hasError = true;
        //let msg = `Status Code ${error.status} on url ${error.url}`;
        //console.error(msg);
        return throwError(() => error);
    }
}
